import { clone, path } from 'ramda';

export function linkDataToFields(data, fields, objMutateData, extraFields) {
  for (let item in fields) {
    let mutateField = false;
    let isArray = false;
    let currentItem = fields[item];
    if (Array.isArray(currentItem) && data && data[item] && extraFields && extraFields[item]) {
      for (let i = 0; i < data[item].length; i++) {
        const clonedField = clone(extraFields[item]);
        clonedField.id = i;
        delete clonedField._system;
        if (data[item][i].id) {
          if(clonedField[extraFields[item].name]) {
            clonedField[extraFields[item].name].id = data[item][i].id;
          } else {
            clonedField.id = data[item][i].id;
          }
        }
        const remappedItem = linkDataToFields(data[item][i], clonedField);

        fields[item].push(remappedItem);
      }
    }

    let dataForMutate = data[path(['system', 'name'], currentItem)];
    if (!dataForMutate) {
      dataForMutate = data[path(['system', 'altName'], currentItem)];
    }

    if (!isArray && objMutateData && objMutateData[item] && data && currentItem.system && currentItem.system.name && dataForMutate !== undefined) {
      fields[item].value = objMutateData[item](currentItem, dataForMutate);
      mutateField = true;
    }
    if (!isArray && !mutateField && data && currentItem.system && currentItem.system.name && data[currentItem.system.name] !== undefined) {
      fields[item].value =  data[currentItem.system.name];
    }
  }
  return fields;
}

const checkItemExistsInStack = (item, stack, comparePath) => {
  const result = stack.findIndex(obj => {
    return path(comparePath, item) === path(comparePath, obj)
  });

  return result >= 0;
};



// WEBPACK FOOTER //
// ./src/utils/fields.js